// components
import { HOME_COMPONENTS } from './home/index';
import { SIGNIN_COMPONENTS } from './signin/index';
import { COMMON_COMPONENTS } from './common/index';
import { DASHBOARD_COMPONENTS } from './dashboard/index';

export const APP_COMPONENTS: any[] = [
  ... SIGNIN_COMPONENTS,
  ... HOME_COMPONENTS,
  ... COMMON_COMPONENTS,
  ... DASHBOARD_COMPONENTS,
];


// services
import { NavigationStateService } from './dashboard/navigation/navigation.state.service';
import { SettingsStateService } from './dashboard/settings/settings.state.service';
import { CONTRACTS_SERVICES } from './dashboard/contracts/index';
import { FORSIGNING_SERVICES } from './dashboard/for-signing/index';
import { CreateDialogStateService } from './dashboard/communications/create-dialog-communications/create.dialog.communications.state.service';
import { CommunicationsStateService } from './dashboard/communications/communications.state.service';
import { ActDialogStateService } from './dashboard/contracts/act-dialog/act.dialog.contracts.state.service';
import { AttachmentStateService } from './common/attachment/attachment.state.service';
import { CreateDialogContractStateService } from './dashboard/contracts/create-quest/create.dialog.state.service';
import { CreateDialogPersonalStateService } from './dashboard/personal/create-quest/create.dialog.state.service';

export const COMPONENTS_SERVICES: any[] = [
  NavigationStateService,
  SettingsStateService,
  ...CONTRACTS_SERVICES,
  ...FORSIGNING_SERVICES,
  CreateDialogStateService,
  CommunicationsStateService,
  ActDialogStateService,
  AttachmentStateService,
  CreateDialogContractStateService,
  CreateDialogPersonalStateService,
];



// WEBPACK FOOTER //
// ./src/app/components/index.ts